<div class="wm-m-screenshotviewer-wrapper">
  <div class="info-tool-bar">
    @if (activeOverlay) {
      <div class="current-tool-info">
        <div class="properties">
          @if (activeOverlay.overlayData.type === 'RectangleOverlayData') {
            <wm-colorchooser (colorSelected)="changeColor($event)" [color]="activeOverlay?.overlayData.color || 'red'"></wm-colorchooser>
          }
          @if (activeOverlay.overlayData.type === 'ArrowOverlayData') {
            <wm-colorchooser (colorSelected)="changeColor($event)" [color]="activeOverlay?.overlayData.color || 'red'"></wm-colorchooser>
          }
          @if (activeOverlay.overlayData.type === 'TextOverlayData') {
            <div class="font-size-button" (click)="increaseFontSize()">
              <fa-icon [icon]="faText"></fa-icon>
              <fa-icon [icon]="faArrowUp" size="xs"></fa-icon>
            </div>
            <div class="font-size-button" (click)="decreaseFontSize()">
              <fa-icon [icon]="faText"></fa-icon>
              <fa-icon [icon]="faArrowDown" size="xs"></fa-icon>
            </div>
            <input pInputText type="text" [(ngModel)]="activeOverlay.overlayData.text" (ngModelChange)="showOverlays()">
            <wm-colorchooser (colorSelected)="changeColor($event)" [color]="activeOverlay?.overlayData.textColor || 'red'"></wm-colorchooser>
          }
        </div>
        @if (activeOverlay && !activeOverlay.hidden) {
          <p-button pTooltip="Hide overlay"  tooltipPosition="top"  styleClass="p-button-text p-button-warn" icon="true" ><fa-icon [icon]="faEyeSlash" (click)="toggleHideOverlay()" [fixedWidth]="true"></fa-icon></p-button>
        }
        @if (activeOverlay && activeOverlay.hidden) {
          <p-button pTooltip="Unhide overlay"  tooltipPosition="top"  styleClass="p-button-text p-button-warn" icon="true" ><fa-icon [icon]="faEye" (click)="toggleHideOverlay()" [fixedWidth]="true"></fa-icon></p-button>
        }
        <p-button styleClass="p-button-text p-button-warn" icon="true" >
          @if (activeOverlay) {
            <fa-icon [icon]="faTrash" (click)="deleteOverlay(activeOverlay.id)" pTooltip="Delete selected overlay" tooltipPosition="top" [fixedWidth]="true"></fa-icon>
          }
        </p-button>
      </div>
    }
    <div class="tools">
      <div class="tool" [ngClass]="{'active': activeTool?.name === 'pointer'}" (click)="activateTool('pointer');"><fa-icon [icon]="faMousePointer" pTooltip="Select item" tooltipPosition="top" [fixedWidth]="true"></fa-icon></div>
      <div class="tool" [ngClass]="{'active': activeTool?.name === 'arrow'}" (click)="activateTool('arrow');"><fa-icon [icon]="faLongArrowRight" pTooltip="Add arrows" tooltipPosition="top" [fixedWidth]="true"></fa-icon></div>
      <div class="tool" [ngClass]="{'active': activeTool?.name === 'rectangle'}" (click)="activateTool('rectangle');" pTooltip="Add rectangles" tooltipPosition="top" ><fa-icon [icon]="faRectangleLandscape" [fixedWidth]="true"></fa-icon></div>
      <div class="tool" [ngClass]="{'active': activeTool?.name === 'text'}"  (click)="activateTool('text');" pTooltip="Add text" tooltipPosition="top" ><fa-icon [icon]="faText" [fixedWidth]="true"></fa-icon></div>
    </div>

    <div class="controls">
      @if (dirty) {
        <p-button styleClass="p-button-text" (click)="save();" icon="true" pTooltip="Save changes" [disabled]="!dirty"><fa-icon [icon]="faSave" [fixedWidth]="true"></fa-icon></p-button>
      }
      <p-button styleClass="p-button-text" (click)="cancel();" icon="true" [pTooltip]="dirty ? 'Close without saving' : 'Close'"><fa-icon [icon]="faTimes" [fixedWidth]="true"></fa-icon></p-button>
    </div>
  </div>
  <div class="image-container">
    <wm-image [displayMode]="'with_draw_canvas'"
              [editable]="true" [ngClass]="'tool-' + activeTool.name"
              [imageUrl]="data.imageUrl"
              [imageId]="data.imageId"
              [fillContainer]="fillContainer"
              [additionalOverlays]="shownOverlays"
              [overlayHandlesFor]="overlayHandlesFor"
              (overlayHit)="onOverlayHit($event)">
    </wm-image>
  </div>
</div>
